<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div class="tabulator-parent">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-briefcase"></i> {{ _('Financial Management') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('settings')" class="tab-pane active" id="settings" v-if="isTabActive('settings')" key="settings">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ settingsTabTitle }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group" data-search="use-netvisor">
                  <label>
                    <input type="checkbox" v-model="settings.pay_option13" true-value="1" false-value="0" /> {{ _('Use Netvisor') }}
                  </label>
                </div>
                <div class="form-group">
                  <label for="netvisor_customerid">{{ _('Netvisor Customer ID') }}</label>
                  <input type="text" class="form-control" id="netvisorCustomerId" :placeholder="_('Enter your Netvisor Customer ID')" v-model="settings.netvisor_customerid" />
                </div>
                <div class="form-group">
                  <label for="netvisor_organizationid">{{ _('Netvisor Organization ID') }}</label>
                  <input type="text" class="form-control" id="netvisorOrganizationId" :placeholder="_('Enter your Netvisor Organization ID')" v-model="settings.netvisor_organizationid" />
                </div>
                <div class="form-group">
                  <label for="netvisor_userkey">{{ _('Netvisor User Key') }}</label>
                  <input type="text" class="form-control" id="netvisorUserKey" :placeholder="_('Enter your Netvisor User Key')" v-model="settings.netvisor_userkey" />
                </div>
                <div class="form-group">
                  <label for="netvisor_secondname">{{ _('Auxiliary business name') }}</label>
                  <input type="text" class="form-control" id="netvisorSecondName" :placeholder="_('Enter the Auxiliary Business Name in Netvisor')" v-model="settings.netvisor_secondname" />
                  <p>{{ _('You can optionally input an auxiliary business name in this field. The name must be defined in Netvisor.') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('briox')" class="tab-pane active" id="briox" v-if="isBrioxSetupVisible && isTabActive('briox')" key="briox">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Briox') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group" data-search="use-briox">
                  <label>
                    <input type="checkbox" v-model="settings.pay_option20" true-value="1" false-value="0" /> {{ _('Use Briox') }}
                  </label>
                </div>
                <div class="form-group">
                  <label for="briox_accountid">{{ _('Briox Account ID') }}</label>
                  <input type="text" class="form-control" id="brioxAccountId" :placeholder="_('Enter your Briox Account ID')" v-model="settings.briox_accountid" />
                </div>
                <div class="form-group">
                  <label for="briox_apptoken">{{ _('Briox Authentication Token') }}</label>
                  <input type="text" class="form-control" id="brioxAppToken" :placeholder="_('Generate in Briox Admin → Users → Authentication token')" v-model="settings.briox_apptoken" />
                </div>
                <div class="form-group" data-search="briox-sync">
                  <label>{{ _('Initial data synchronization') }}</label>
                  <div class="input-group">
                    <button type="button" class="btn btn-info" v-on:click="brioxSync">{{ _('Synchronize') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('nocfo')" class="tab-pane active" id="nocfo" v-if="isNocfoSetupVisible && isTabActive('nocfo')" key="nocfo">
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('NoCFO') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group" data-search="use-nocfo">
                  <label>
                    <input type="checkbox" v-model="settings.pay_option21" true-value="1" false-value="0" /> {{ _('Use NoCFO') }}
                  </label>
                </div>
                <div class="form-group">
                  <label for="nocfo_token">{{ _('Personal Access Token') }}</label>
                  <input type="text" class="form-control" id="nocfoToken" :placeholder="_('Enter your NoCFO Personal Access Token')" v-model="settings.nocfo_token" />
                </div>
                <div class="form-group">
                  <label for="nocfo_business_slug">{{ _('Business slug') }}</label>
                  <input type="text" class="form-control" id="nocfoBusinessSlug" :placeholder="_('Enter your NoCFO business slug')" v-model="settings.nocfo_business_slug" />
                </div>
                <div class="form-group" v-if="isSuperAdmin">
                  <label for="nocfo_base_url">{{ _('API base URL') }}</label>
                  <input type="text" class="form-control" id="nocfoBaseUrl" :placeholder="_('Leave empty for production')" v-model="settings.nocfo_base_url" />
                </div>
                <div class="form-group" data-search="nocfo-sync">
                  <label>{{ _('Initial data synchronization') }}</label>
                  <div class="input-group">
                    <button type="button" class="btn btn-info" v-on:click="nocfoSync">{{ _('Synchronize') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('dimensions')" class="tab-pane active" id="dimensions" v-if="isTabActive('dimensions')" key="dimensions">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <button type="button" class="btn btn-success pull-right" id="importDimensions" v-on:click="importDimensions"><i class="fa fa-fw fa-plus"></i> {{ _('Import cost objects') }}</button>
                  <h3>{{ _('Cost objects') }}</h3>
                  <draggable-multi-selector v-model="dimensions" :items="allDimensions" :groups="true" :single-select="isBrioxAccountingMode" itemProperty="name" :selectorTitle="_('Link a Cost object')" />
                  <p>{{ _('Selected cost objects will be applied to all sales from this shop.') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('accounts')" class="tab-pane active" id="accounts" v-if="isTabActive('accounts')" key="accounts">
            <div class="row">
              <div class="col-xs-12">
                <button type="button" class="btn btn-success pull-right" id="importAccounts" v-on:click="importAccounts" :disabled="importingAccounts"><i :class="'fa fa-fw fa-' + (importingAccounts ? 'cog fa-spin' : 'plus')"></i> {{ importingAccounts ? _('Processing') + '...' : _('Import accounts') }}</button>
                <h3>{{ _('Accounts') }}</h3>
              </div>
            </div>
            <!-- <div style="height: 800px"> "Mom says hi". -->
            <!-- "This is hacky." "Hello Hacky, this is dad." -->
            <Datatable :url="accountsUrl" :options="accountsTableOptions" ref="datatable" />
            <!-- </div> "Also mom" -->
          </div>
          <div v-bind="tabPanel('accountmapping')" class="tab-pane active" id="accountmapping" v-if="isTabActive('accountmapping')" key="accountmapping">
            <div class="row" data-search="advance-accounts">
              <div class="col-xs-12">
                <h3>{{ _('Advance accounts') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label :for="accountField('advances_01')">{{ _('January') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_01')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_01'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_02')">{{ _('February') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_02')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_02'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_03')">{{ _('March') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_03')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_03'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_04')">{{ _('April') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_04')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_04'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_05')">{{ _('May') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_05')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_05'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_06')">{{ _('June') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_06')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_06'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_07')">{{ _('July') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_07')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_07'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_08')">{{ _('August') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_08')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_08'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_09')">{{ _('September') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_09')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_09'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_10')">{{ _('October') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_10')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_10'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_11')">{{ _('November') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_11')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_11'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_12')">{{ _('December') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_12')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_12'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label :for="accountField('advances_future')">{{ _('Upcoming') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('advances_future')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeAccountButton" v-on:click="changeAccountDialog(accountField('advances_future'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <h3>{{ _('Discounts account') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group" data-search="discounts-account">
                  <label :for="accountField('discounts')">{{ _('Discounts account') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('discounts')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeDiscountAccountButton" v-on:click="changeAccountDialog(accountField('discounts'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group" data-search="zero-vat-account">
                  <label :for="accountField('zerovat')">{{ _('Zero VAT sales account') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('zerovat')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeZeroVatAccountButton" v-on:click="changeAccountDialog(accountField('zerovat'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" data-search="value-card-accounts">
              <div class="col-xs-12">
                <h3>{{ _('Value card accounts') }}</h3>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label :for="accountField('multiuse')">{{ _('Multi-use value card account') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('multiuse')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeMultiUseAccountButton" v-on:click="changeAccountDialog(accountField('multiuse'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label :for="accountField('singleuse')">{{ _('Single-use value card account') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control netvisor-account" disabled="disabled" :value="getAccountName(settings[accountField('singleuse')])" />
                    <span class="input-group-btn">
                      <button type="button" class="btn btn-info changeSingleUseAccountButton" v-on:click="changeAccountDialog(accountField('singleuse'))">{{ _('Select') }}</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>

import axios from 'axios'
import components from '~/lib/components'
import settingseditors from '~/lib/settingseditors'
import { mapGetters } from 'vuex'
import dimensions from '~/lib/dimensions'
import briox from '~/lib/briox'
import nocfo from '~/lib/nocfo'
import permissions from '~/lib/permissions'
import settingshelpers from '~/lib/settingshelpers'
import { Datatable, DraggableMultiSelector } from '#components'

export default {
  data () {
    const _ = useNuxtApp().$translate
    return {
      localSettings: null,
      activeTab: 'settings',
      dimensions: [],
      accounts: [],
      importingAccounts: false,
      accountsTableOptions: {
        columns: [
        {
          title: 'ID',
          field: 'id',
          width: 70,
          responsive: 0
        },
        {
          title: _('Name'),
          field: 'name',
          widthGrow: 3,
          responsive: 0
        },
        {
          title: _('Parent'),
          field: 'parentname',
          widthGrow: 2
        },
        {
          title: _('Type'),
          field: 'accounttype',
          widthGrow: 1
        },
        ],
        initialSort: [{
          column: 'name',
          dir: 'asc'
        }]
      }
    }
  },
  mixins: [components, dimensions, settingseditors, briox, nocfo, permissions, settingshelpers],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'settings', label: this.settingsTabTitle },
        { id: 'briox', label: this._('Briox'), hidden: !this.isBrioxSetupVisible },
        { id: 'nocfo', label: this._('NoCFO'), hidden: !this.isNocfoSetupVisible },
        { id: 'dimensions', label: this._('Cost objects') },
        { id: 'accounts', label: this._('Accounts') },
        { id: 'accountmapping', label: this._('Account mapping') }
      ])
    },
    accountsUrl () {
      return this.baseDomain + this.shopId + '/accounts.json?apikey=' + this.apiKey
    },
    editorConfig () {
      return {
        toolbar:
          [
            ['Format', 'Bold', 'Italic', '-', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', '-', 'Link', 'Unlink'],
            ['JustifyLeft', 'JustifyCenter', 'JustifyRight'],
            ['Undo', 'Redo'],
            ['Source'],
            ['UIColor']
          ],
        height: '200px',
        language: this.shortLocale,
        allowedContent: true,
        extraPlugins: 'justify'
      }
    },
    accountsTree () {
      const parents = {}
      const root = []
      const children = {}
      for (let i = 0; i < this.accounts.length; i++) {
        const item = this.accounts[i]
        parents[item.id] = item
        if (parseInt(item.parentid)) {
          if (!children[item.parentid]) {
            children[item.parentid] = []
          }
          children[item.parentid].push(item)
        } else {
          root.push(parents[item.id])
        }
      }
      for (let id in parents) {
        if (Object.prototype.hasOwnProperty.call(parents, id)) {
          let item = parents[id]
          if (children[id]) {
            item.children = children[id]
          } else {
            item.children = []
          }
        }
      }
      return root
    },
    accountOptions () {
      return this.getAccountOptions(this.accountsTree)
    },
    accountMappingPrefix () {
      if (parseInt(this.settings.pay_option21)) {
        return 'nocfo'
      }
      if (parseInt(this.settings.pay_option20)) {
        return 'briox'
      }
      return 'netvisor'
    }
  },
  methods: {
    accountField (name) {
      return this.accountMappingPrefix + '_' + name
    },
    getAccountOptions (tree, level = 0) {
      let options = []
      if (tree && tree.length > 0) {
        for (let i = 0; i < tree.length; i++) {
          const a = tree[i]
          options.push({ 
            value: a.number, 
            name: '&nbsp;'.repeat(4 * level) + (parseInt(a.number) ? a.number + ' ' : '') + a.name, 
            disabled: !parseInt(a.number)
          })
          options = [...options, ...this.getAccountOptions(a.children, level + 1)]
        }
      }
      return options
    },
    getAccountName (id) {
      if (!parseInt(id)) {
        return ''
      }
      const account = this.accounts.find(a => parseInt(a.number, 10) === parseInt(id, 10))
      if (account) {
        return id + ' ' + account.name
      }
      return id
    },
    changeAccountDialog (account) {
      const buttons = [
        {
          title: this._('Cancel'),
          icon: 'close',
          handler: () => {}
        }
      ]
      if (parseInt(this.settings[account])) {
        buttons.push({
          title: this._('Remove'),
          class: 'danger',
          icon: 'trash',
          handler: () => {
            this.selectAccount(account, '')
          }
        })
      }
      buttons.push({
        title: this._('Ok'),
        class: 'success',
        icon: 'check',
        requiredFields: ['account'],
        handler: (data) => {
          this.selectAccount(account, data.account)
        }
      })
      this.showDialog({
        title: this._('Select an account'),
        width: 800,
        buttons,
        fields: [
          {
            title: this._('Account'),
            type: 'select',
            name: 'account',
            options: this.accountOptions,
            defaultValue: this.settings[account]
          }
        ]
      })
    },
    selectAccount(account, newValue) {
      this.settings[account] = newValue
    },
    async importDimensions () {
      let response
      const data = {
        import: 1
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/dimensions.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        return
      }
      this.loadAllDimensions()
    },
    async importAccounts () {
      if (this.importingAccounts) {
        return
      }
      this.importingAccounts = true
      let response
      const data = {
        import: 1
      }
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/accounts.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e)
        this.importingAccounts = false
        return
      }
      await this.loadAccounts()
      this.importingAccounts = false
    },
    close () {
      if (this.component && this.component.initData && this.component && this.component.initData.modal) {
        this.$emit('close')
      } else {
        this.EventBus.$emit('hideDetailsColumn', {
          shopId: this.shopId
        })
      }
    },
    loadDimensions () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/settings/1/dimensions.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          resolve([])
          return
        }
        this.dimensions = response.data
        resolve(this.dimensions)
      })
    },
    loadAccounts () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/accounts.json?apikey=' + this.apiKey)
        } catch(e) {
          this.showError(e)
          resolve([])
          return
        }
        this.accounts = response.data
        resolve(this.accounts)
      })
    },
    getSaveData () {
      const exportFields = [
        'id', 
        'pay_option13',
        'netvisor_customerid',
        'netvisor_organizationid',
        'netvisor_userkey',
        'netvisor_secondname',
        'netvisor_advances_01',
        'netvisor_advances_02',
        'netvisor_advances_03',
        'netvisor_advances_04',
        'netvisor_advances_05',
        'netvisor_advances_06',
        'netvisor_advances_07',
        'netvisor_advances_08',
        'netvisor_advances_09',
        'netvisor_advances_10',
        'netvisor_advances_11',
        'netvisor_advances_12',
        'netvisor_advances_future',
        'netvisor_discounts',
        'netvisor_multiuse',
        'netvisor_singleuse',
        'pay_option20',
        'briox_accountid',
        'briox_apptoken',
        'briox_advances_01',
        'briox_advances_02',
        'briox_advances_03',
        'briox_advances_04',
        'briox_advances_05',
        'briox_advances_06',
        'briox_advances_07',
        'briox_advances_08',
        'briox_advances_09',
        'briox_advances_10',
        'briox_advances_11',
        'briox_advances_12',
        'briox_advances_future',
        'briox_discounts',
        'briox_zerovat',
        'briox_multiuse',
        'briox_singleuse',
        'pay_option21',
        'nocfo_token',
        'nocfo_business_slug',
        'nocfo_base_url',
        'nocfo_advances_01',
        'nocfo_advances_02',
        'nocfo_advances_03',
        'nocfo_advances_04',
        'nocfo_advances_05',
        'nocfo_advances_06',
        'nocfo_advances_07',
        'nocfo_advances_08',
        'nocfo_advances_09',
        'nocfo_advances_10',
        'nocfo_advances_11',
        'nocfo_advances_12',
        'nocfo_advances_future',
        'nocfo_discounts',
        'nocfo_zerovat',
        'nocfo_multiuse',
        'nocfo_singleuse'
      ]
      const data = exportFields.reduce((a, e) => (a[e] = this.settings[e], a), {})
      data.accounting = 1
      data.dimensions = this.dimensions.map(d => d.id)
      return data
    },
    async save (payment) {
      this.saving = true
      const data = this.getSaveData()
      let response
      try {
        if (data.id) {
          response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
        } else {
          this.saving = false
          return
        }
      } catch(e) {
        this.saving = false
        return this.showError(e)
      }
      this.saving = false
      this.saved = true
      this.storeState()
      setTimeout(() => { this.saved = false }, 1000)
      this.showNotification(this._('Changes saved successfully!'))
      this.$emit('save', this.settings)
      this.close()
    }
  },
  components: {
    Datatable,
    DraggableMultiSelector
  },
  async mounted () {
    this.localSettings = Object.assign({}, this.settings)
    await this.loadDimensions()
    await this.loadAccounts()
    this.storeState()
  }
}
</script>